import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "services/api";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { addCountries } from "../../redux/slices/profile_slice";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import CustomDatePicker from "components/CustomDatePicker";
import { toast } from "react-toastify";

export const Registration = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [loginType, setLoginType] = useState("Personal");
  const { countries } = useSelector((state) => state?.profile);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);


  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 16);
  const [industries, setIndustries] = useState([]);

  let initialValues = {
    first_name: "",
    middle_name: "",
    last_name: "",
    email: location?.state?.email || "",
    phone_no: "",
    dob: "",
    sex: "",
    password: "",
    password_confirmation: "",
    agree: false,
    nationality: "95",
    corporate_name: "",
    corporate_contact_email: "",
    corporate_address: "",
    corporate_contact_phone: "",
    corporate_industry_id: "",
    corporate_parent_id: "",
  };
  const validationSchema = Yup.object({
    first_name: Yup.string()
      .required("Required")
      .matches(/^[A-Za-z]+$/, "Only Alphabets"),
    middle_name: Yup.string().matches(/^[A-Za-z]+$/, "Only Alphabets"),
    last_name: Yup.string()
      // .required("Required")
      .matches(/^[A-Za-z]+$/, "Only Alphabets"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Required")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Invalid email format"
      ),
    phone_no: Yup.string()
      .required("Required")
      .matches(/[0-9]+$/, "Only numeric")
      .length(10, "Phone number must be exactly 10 digits"),
    dob: Yup.string()
      .required("DOB is required")
      .test("min-date", "You must be at least 16 years old", (value) => {
        const selectedDate = moment(value, "DD-MM-YYYY");
        const minDate = moment().subtract(16, "years").startOf("day").toDate();
        return selectedDate.isSameOrBefore(minDate);
      }),
    sex: Yup.string().required("Required"),
    nationality: Yup.string().required("Required"),
    password: Yup.string()
      .required("Password is Required")
      .min(8, "Password must be at least 8 characters")
      .max(30, "Password must be at most 30 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      ),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Required"),
    corporate_name:
      loginType === "Corporate"
        ? Yup.string()
          .required("Required")
          .matches(/^[A-Za-z0-9' -;:,.&]+$/)
        : Yup.string(),
    corporate_contact_email:
      loginType === "Corporate"
        ? Yup.string()
          .email("Invalid email address")
          .required("Required")
          .matches(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
            "Invalid email format"
          )
        : Yup.string(),
    corporate_contact_phone:
      loginType === "Corporate"
        ? Yup.string()
          .required("Required")
          .matches(/[0-9]+$/, "Only numeric")
          .length(10, "Phone number must be exactly 10 digits")
        : Yup.string(),
    corporate_industry_id:
      loginType === "Corporate"
        ? Yup.string().required("Required")
        : Yup.string(),
    corporate_address:
      loginType === "Corporate"
        ? Yup.string()
          .required("Required")
          .matches(/^[A-Za-z0-9' -;:,.&]+$/)
        : Yup.string(),

    agree: Yup.boolean()
      .oneOf([true], "Must agree to terms and conditions")
      .required("Required"),
  });

  const handleSubmit = (values) => {
    setLoader(true);
    console.log("Form Values:", values);

    const urlT = loginType === "Corporate" ? "/register" : "/registerPersonal";
    let payload = {
      ...values,
      password_confirmation: values.password,
      corporate_parent_id: values.corporate_parent_id || null,
    };
    delete payload.agree;
    api
      .post(urlT, payload)
      .then((res) => {
        setLoader(false);
        console.log("Registration:", res);

        toast.success(res?.data?.message);
        navigate("/afterRegistration");
      })
      .catch((err) => {
        let message = err?.response?.data?.message || "Failed To Register";
        toast.error(message);
        setLoader(false);
      });
  };
  const fetchIndustries = async () => {
    try {
      const response = await api.get("/industries");
      const result = response?.data?.data || [];
      setIndustries(result);
      console.log("fetchIndustries:", result);
    } catch (error) {
      console.log("fetchIndustries Error:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (countries?.length === 0) {
          await api.get("/countries").then((res) => {
            let countriesList = res?.data?.data?.countries || [];
            if (countriesList?.length > 0) {
              dispatch(addCountries(countriesList));
            }
          });
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
    };
    fetchData();
    fetchIndustries();
  }, [countries?.length, dispatch]);

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        <div className="d-none d-lg-flex col-lg-6 p-0">
          <div className="auth-cover-bg  d-flex justify-content-center align-items-center">
            <img
              src="../../assets/img/SignupImage.png"
              alt="auth-register-cover"
              className="img-fluid my-5 signup-positioned-image image-size"
            />
          </div>
        </div>

        <div className="d-flex col-12 col-lg-6 align-items-center p-sm-5 p-4">
          <div className="w-px-600 mx-auto">
            <div className="app-brand mb-2">
              <Link to="index.html" className="app-brand-link gap-2">
                <span className="app-brand-logo demo">
                  <img
                    src="../../assets/img/flowersvg.svg"
                    style={{
                      width: "40px",
                      height: "26px",
                      borderRadius: "50%",
                    }}
                    alt="brand-logo"
                  />
                </span>
              </Link>
            </div>

            <h3 className="mb-1">Your savings begin here.</h3>
            <p className="mb-4">
              Discover cashbacks, discounts and other perks!!!
            </p>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              // validateOnBlur={true}
              onSubmit={(values) => {
                console.log(values);
                handleSubmit(values);
              }}
            >
              {({
                errors,
                values,
                setFieldValue,
                resetForm,
                validateField,
                handleBlur,
              }) => (
                <Form>
                  {console.log("errors:", errors)}
                  {console.log("values:", values)}
                  <ul className="nav nav-pills d-flex mb-4">
                    <li className="nav-item col-4">
                      <button
                        type="button"
                        className={`nav-link ${loginType === "Personal" && "active"
                          }`}
                        onClick={() => {
                          setLoginType("Personal");
                          resetForm();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Personal
                      </button>
                    </li>

                    <li className="nav-item mx-2 col-4">
                      <button
                        type="button"
                        className={`nav-link ${loginType === "Corporate" && "active"
                          }`}
                        onClick={() => {
                          setLoginType("Corporate");
                          resetForm();
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Corporate
                      </button>
                    </li>
                  </ul>
                  <h5 class="card-header pb-3">
                    Kindly fill your details as per Aadhaar Card
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-4 col-12">
                      <label for="first_name" className="form-label">
                        First Name{" "}
                        {/* <small>(Kindly fill the name as per Aadhar Card)</small>{" "} */}
                        <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="first_name"
                        placeholder="First Name"
                        autofocus
                        onChange={(e) => {
                          if (/^[A-Za-z ]*$/.test(e.target.value)) {
                            setFieldValue("first_name", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label for="middle_name" className="form-label">
                        Middle Name
                      </label>
                      <Field
                        type="text"
                        className={`form-control`}
                        name="middle_name"
                        placeholder="Middle Name"
                        // autofocus
                        onChange={(e) => {
                          if (/^[A-Za-z ]*$/.test(e.target.value)) {
                            setFieldValue("middle_name", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="middle_name"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label for="last_name" className="form-label">
                        Last Name
                      </label>

                      <Field
                        type="text"
                        className={`form-control `}
                        name="last_name"
                        placeholder="Last Name"
                        autofocus
                        onChange={(e) => {
                          if (/^[A-Za-z ]*$/.test(e.target.value)) {
                            setFieldValue("last_name", e.target.value);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6 col-12">
                      <label for="email" className="form-label">
                        Email <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="email"
                        className={`form-control`}
                        name="email"
                        placeholder="Enter your Email "
                        autofocus
                        onChange={(e) => {
                          const email = e.target.value;
                          const isValidEmail = /^[A-Za-z0-9@.]*$/.test(email);
                          if (isValidEmail) {
                            setFieldValue("email", email);
                          }
                        }}
                      />

                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-form"
                      />
                    </div>

                    <div className="col-md-6 col-12">
                      <label for="phone_no" className="form-label">
                        Phone No <span className="invalid-form">*</span>
                      </label>
                      <Field
                        type="tel"
                        className={`form-control`}
                        name="phone_no"
                        placeholder="Enter your  Phone No"
                        autofocus
                        value={values.phone_no}
                        onChange={(e) => {
                          if (/^[0-9]*$/.test(e.target.value)) {
                            setFieldValue("phone_no", e.target.value);
                          }
                        }}
                        maxLength="10"
                      />
                      <ErrorMessage
                        name="phone_no"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-4 col-12">
                      <label for="dob" className="form-label">
                        DOB <span className="invalid-form">*</span>
                      </label>
                      {/* <Field
                        type="date"
                        className={`form-control`}
                        name="dob"
                        placeholder=""
                        autofocus
                        onChange={(e) => {
                          handleDobChange(e, setFieldValue);
                        }}
                      /> */}
                      <Field
                        name="dob"
                        component={CustomDatePicker}
                        value={values.dob}
                        validateField={validateField} // Pass validateField function to custom component
                        handleBlur={handleBlur}
                      //  max={moment().subtract(16, 'years').startOf('day').toDate()}
                      />
                      {errors?.dob === "DOB is required" && (
                        <ErrorMessage
                          name="dob"
                          component="div"
                          className="invalid-form"
                        />
                      )}
                      {errors?.dob && errors?.dob !== "DOB is required" && (
                        <p className="invalid-form">{errors.dob}</p>
                      )}
                    </div>
                    <div className="col-md-4 col-12">
                      <label className="form-label" for="sex">
                        Gender <span className="invalid-form">*</span>
                      </label>

                      <Field
                        as="select"
                        className="select2 form-select"
                        name="sex"
                      >
                        <option value="">Select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </Field>
                      <ErrorMessage
                        name="sex"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                    <div className="col-md-4 col-12">
                      <label for="nationality" className="form-label">
                        Country <span className="invalid-form">*</span>
                      </label>
                      <Field
                        as="select"
                        className="select2 form-select"
                        name="nationality"
                      >
                        <option value="">Select</option>
                        {countries.map((country) => {
                          return (
                            <option value={country?.id}>{country?.name}</option>
                          );
                        })}
                      </Field>
                      <ErrorMessage
                        name="nationality"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6 col-12 form-password-toggle">
                      <div className="d-flex justify-content-between">
                        <label className="form-label" for="password">
                          Password <span className="invalid-form">*</span>
                        </label>
                      </div>
                      <div className="input-group input-group-merge ">
                        <Field
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className={`form-control `}
                          placeholder="••••••••••••"
                          aria-describedby="password"
                        />
                        <span
                          className="input-group-text"
                          style={{ cursor: "pointer" }}
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                          />
                        </span>
                      </div>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="invalid-form"
                      />
                    </div>

                    <div className="col-md-6 col-12 form-password-toggle">
                      <div className="d-flex justify-content-between">
                        <label className="form-label" for="password">
                          Confirm Password
                          <span className="invalid-form">*</span>
                        </label>
                      </div>
                      <div className="input-group input-group-merge ">
                        <Field
                          type={showPassword2 ? "text" : "password"}
                          name="password_confirmation"
                          className={`form-control`}
                          placeholder="••••••••••••"
                          aria-describedby="password"
                        />
                        <span
                          onClick={() => setShowPassword2(!showPassword2)}
                          className="input-group-text"
                          style={{ cursor: "pointer" }}
                        >
                          <FontAwesomeIcon
                            icon={showPassword2 ? faEyeSlash : faEye}
                          />
                        </span>
                      </div>
                      <ErrorMessage
                        name="password_confirmation"
                        component="div"
                        className="invalid-form"
                      />
                    </div>
                  </div>

                  {loginType === "Corporate" && (
                    <>
                      <div className="row mb-3">
                        <div className="col-md-6 col-12">
                          <label for="corporate_name" className="form-label">
                            Corporate Name{" "}
                            <span className="invalid-form">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control`}
                            name="corporate_name"
                            placeholder="Corporate Name"
                            autofocus
                            onChange={(e) => {
                              if (
                                /^[A-Za-z0-9 .,:;'&-]*$/.test(e.target.value)
                              ) {
                                setFieldValue("corporate_name", e.target.value);
                              }
                            }}
                          />
                          <ErrorMessage
                            name="corporate_name"
                            component="div"
                            className="invalid-form"
                          />
                        </div>
                        <div className="col-md-6 col-12">
                          <label
                            for="corporate_contact_email"
                            className="form-label"
                          >
                            Corporate Contact Email
                            <span className="invalid-form">*</span>
                          </label>

                          <Field
                            type="email"
                            className={`form-control `}
                            name="corporate_contact_email"
                            placeholder="Corporate Contact Email"
                            autofocus
                            onChange={(e) => {
                              const Email = e.target.value;
                              const isValidEmail = /^[A-Za-z0-9@.]*$/.test(
                                Email
                              );
                              if (isValidEmail) {
                                setFieldValue("corporate_contact_email", Email);
                              }
                            }}
                          />

                          <ErrorMessage
                            name="corporate_contact_email"
                            component="div"
                            className="invalid-form"
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6 col-12">
                          <label
                            for="corporate_contact_phone"
                            className="form-label"
                          >
                            Corporate Contact Phone{" "}
                            <span className="invalid-form">*</span>
                          </label>
                          <Field
                            type="tel"
                            className={`form-control`}
                            name="corporate_contact_phone"
                            placeholder="Corporate Contact Phone No"
                            autofocus
                            onChange={(e) => {
                              if (/^[0-9]*$/.test(e.target.value)) {
                                setFieldValue(
                                  "corporate_contact_phone",
                                  e.target.value
                                );
                              }
                            }}
                            maxLength={10}
                          />
                          <ErrorMessage
                            name="corporate_contact_phone"
                            component="div"
                            className="invalid-form"
                          />
                        </div>
                        <div className="col-md-6 col-12">
                          <label
                            for="corporate_industry_id"
                            className="form-label"
                          >
                            Corporate Industry
                            <span className="invalid-form">*</span>
                          </label>

                          <Field
                            as="select"
                            className={`select2 form-select`}
                            name="corporate_industry_id"
                          >
                            <option value="">Select</option>
                            {industries.map((industry) => (
                              <option key={industry.id} value={industry.id}>
                                {industry.name}
                              </option>
                            ))}
                          </Field>

                          <ErrorMessage
                            name="corporate_industry_id"
                            component="div"
                            className="invalid-form"
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-12">
                          <label for="corporate_address" className="form-label">
                            Corporate Address
                            <span className="invalid-form">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control`}
                            name="corporate_address"
                            placeholder="Corporate Address"
                            autofocus
                            onChange={(e) => {
                              if (
                                /^[A-Za-z0-9 .,:;'&-]*$/.test(e.target.value)
                              ) {
                                setFieldValue(
                                  "corporate_address",
                                  e.target.value
                                );
                              }
                            }}
                          />

                          <ErrorMessage
                            name="corporate_address"
                            component="div"
                            className="invalid-form"
                          />
                        </div>
                        {/* <div className="col-md-6 col-12">
                          <label for="corporate_parent_id" className="form-label">
                            Corporate Parent
                            <span className="invalid-form">*</span>
                          </label>
                          <Field
                            type="text"
                            className={`form-control`}
                            name="corporate_parent_id"
                            placeholder="Corporate Parent"
                            autofocus
                            onChange={(e) => {
                              if (
                                /^[A-Za-z0-9 .,:;'&-]*$/.test(e.target.value)
                              ) {
                                setFieldValue(
                                  "corporate_parent_id",
                                  e.target.value
                                );
                              }
                            }}
                          />

                          <ErrorMessage
                            name="corporate_parent_id"
                            component="div"
                            className="invalid-form"
                          />
                        </div> */}
                      </div>
                    </>
                  )}

                  <div className="mb-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="terms-conditions"
                        name="agree"
                        onChange={(e) => {
                          setFieldValue("agree", e.target.checked);
                        }}
                      />
                      <label
                        className="form-check-label"
                        for="terms-conditions"
                      >
                        I agree to&nbsp;
                        <Link target="blank" to="/termsConditions">
                          terms and conditions
                        </Link>{" "}
                        &
                        <Link target="blank" to="/privacyPolicy">
                          {" "}
                          privacy policy
                        </Link>
                      </label>
                    </div>

                    <ErrorMessage
                      name="agree"
                      component="div"
                      className="invalid-form"
                    />
                  </div>

                  {loader ? (
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary "
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary d-grid w-100"
                      type="submit"
                    >
                      Sign up
                    </button>
                  )}
                </Form>
              )}
            </Formik>

            <p className="text-center mt-3">
              <span className="me-2">Already have an account?</span>
              <Link to="/login">
                <span>Sign in</span>
              </Link>
            </p>

            {/* <div className="divider my-4">
              <div className="divider-text">or</div>
            </div>
            <div className="d-flex justify-content-center">
              <Link
                to="javascript:;"
                className="btn btn-icon btn-label-facebook me-3"
              >
                <i className="tf-icons fa-brands fa-facebook-f fs-5"></i>
              </Link>
              <Link
                to="javascript:;"
                className="btn btn-icon btn-label-google-plus me-3"
              >
                <i className="tf-icons fa-brands fa-google fs-5"></i>
              </Link>

              <Link to="javascript:;" className="btn btn-icon btn-label-twitter">
                <i className="tf-icons fa-brands fa-twitter fs-5"></i>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
